import { Route, Switch } from 'react-router-dom';
import PagesDetailsContainer from '../containers/PagesDetailsContainer';
import ExternalPagesDetailsContainer from '../containers/ExternalPagesDetailsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    component: ExternalPagesDetailsContainer,
    path: "/external-page/optimization"
  }), /*#__PURE__*/_jsx(Route, {
    component: PagesDetailsContainer,
    path: "/:pageTypeSlug/:contentId/:tabId?"
  })]
});